import { Ban } from "lucide-react";

export default function ErrorBox({children}:{children:any}){

    return(
        <div className="w-full bg-secondary rounded-lg">
            <div className="w-full flex items-center gap-2 px-4 py-3 rounded-lg bg-red-900/30 border border-red-800/50 text-red-400 text-sm">
            <Ban className="w-4 h-4 shrink-0" />
            <span>{children}</span>
            </div>
        </div>

    )
}
